import { API_ENDPOINTS } from "../../constants/common";
import { webApi } from "../../utils/api";

export const getCustomerSettings = (account, businessId) =>
  webApi
    .get({
      path: API_ENDPOINTS.ACCOUNT_SETTINGS,
      query: {
        account,
        businessId,
      },
    })
    .then((res) => res.data);

export const updateCustomerSettings = (body) =>
  webApi
    .put({
      path: API_ENDPOINTS.ACCOUNT_SETTINGS,
      body,
    })
    .then((res) => res.data);

export const getChatQueue = (account, businessId) =>
  webApi
    .get({
      path: API_ENDPOINTS.CHAT_QUEUE,
      query: {
        account,
        businessId,
      },
    })
    .then((res) => res.data);

export const updateChatQueue = (body) =>
  webApi
    .put({
      path: API_ENDPOINTS.CHAT_QUEUE,
      body,
    })
    .then((res) => res.data);

export const bulkUpdateChatQueue = (body) =>
  webApi
    .post({
      path: `${API_ENDPOINTS.CHAT_QUEUE}/bulk`,
      body,
    })
    .then((res) => res.data);

export const getChatQueueAccounts = (query) =>
  webApi
    .get({
      path: `${API_ENDPOINTS.CHAT_QUEUE}/accounts`,
      query,
    })
    .then((res) => res.data);
